import React, { useState } from 'react';
import './BuyAsicsPayment.css';
import '../../components/Button/Button.css';
import '../../components/Disclaimer/Disclaimer.css';

// ASIC data mapping based on model ID
const asicData = {
  87: {
    title: 'Antminer S21 XP 270TH/s',
    power: '270 TH/s',
    price: 4650,
    image: 'https://files.ecos.am/asics/png/S21XpGrey.png',
    monthlyOutput: 482,
    breakeven: 349,
    return: 420,
    powerW: '3645 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  91: {
    title: 'Antminer S21 Pro 245TH/s',
    power: '245 TH/s',
    price: 3430,
    image: 'https://files.ecos.am/asics/png/S21ProGrey.png',
    monthlyOutput: 425,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  94: {
    title: 'Antminer S21+ 235TH/s',
    power: '235 TH/s',
    price: 3200,
    image: 'https://files.ecos.am/images/zGulRgMjlfz5wKMY5FIaIq5dQr8TnobaVRgFSACY.png',
    monthlyOutput: 387,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  90: {
    title: 'Antminer S21 Pro 234TH/s',
    power: '234 TH/s',
    price: 3300,
    image: 'https://files.ecos.am/asics/png/S21ProGrey.png',
    monthlyOutput: 400,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  93: {
    title: 'Antminer S21+ 225TH/s',
    power: '225 TH/s',
    price: 2950,
    image: 'https://files.ecos.am/images/wq5or9tbhLJb1aLG1cvh82nIJjmreuEAom1k8r00.png',
    monthlyOutput: 368,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  84: {
    title: 'Antminer S21 200TH/s',
    power: '200 TH/s',
    price: 2650,
    image: 'https://files.ecos.am/asics/png/S21Grey.png',
    monthlyOutput: 302,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  83: {
    title: 'Antminer S21 188TH/s',
    power: '188 TH/s',
    price: 2550,
    image: 'https://files.ecos.am/asics/png/S21Grey.png',
    monthlyOutput: 277,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  92: {
    title: 'Antminer S19j XP 151TH/s',
    power: '151 TH/s',
    price: 1500,
    image: 'https://files.ecos.am/images/mbn8RbhykuaEBbrfb7Qhme0Q2mXQ9EX1zyTtINS6.png',
    monthlyOutput: 197,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  },
  81: {
    title: 'Antminer S19K Pro 120TH/s',
    power: '120 TH/s',
    price: 950,
    image: 'https://files.ecos.am/images/QahvyXHPrUtllh9H4FI5oVINjDUkTzb8PgNkl5tn.png',
    monthlyOutput: 139,
    breakeven: 349,
    return: 420,
    powerW: '3450 W',
    algorithm: 'SHA 256',
    efficiency: '14 W/TH'
  }
};

const BuyAsicsPayment = () => {
  const pathParts = window.location.pathname.split('/');
  const modelId = parseInt(pathParts[3]) || 87;
  const initialQuantity = parseInt(pathParts[4]) || 1;

  const [quantity, setQuantity] = useState(initialQuantity);
  const [hardwareDetailsOpen, setHardwareDetailsOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('btc');
  const [otherCryptoOpen, setOtherCryptoOpen] = useState(false);
  const [promocode, setPromocode] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const asic = asicData[modelId] || asicData[87];

  // Fees are per ASIC unit
  const installationFeePerUnit = 650;
  const monthlyHostingFeePerUnit = 210;

  // Calculate totals
  const asicSubtotal = asic.price * quantity;
  const installationFeeTotal = installationFeePerUnit * quantity;
  const monthlyHostingFeeTotal = monthlyHostingFeePerUnit * quantity;
  
  // Calculate subtotal before discount
  const subtotalBeforeDiscount = asicSubtotal + installationFeeTotal + monthlyHostingFeeTotal;
  
  // Calculate discount based on quantity (bulk orders)
  let discountPercent = 0;
  if (quantity >= 10) {
    discountPercent = 15; // 15% off for 10+ units
  } else if (quantity >= 5) {
    discountPercent = 10; // 10% off for 5-9 units
  }
  
  // Apply discount only to ASIC price, not fees
  const discount = (asicSubtotal * discountPercent) / 100;
  const total = subtotalBeforeDiscount - discount;

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value).replace(',', ' ');
  };

  const handleBack = () => {
    window.history.pushState({ page: 'buy-asics' }, '', '/mining-store/buy-asics');
    window.location.reload();
  };

  const increaseQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const toggleHardwareDetails = () => {
    setHardwareDetailsOpen(prev => !prev);
  };

  const toggleOtherCrypto = () => {
    setOtherCryptoOpen(prev => !prev);
  };

  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method);
    if (method !== 'crypto') {
      setOtherCryptoOpen(false);
    }
  };

  return (
    <div className="order-container-wrapper">
      {/* Header Section */}
      <div className="holder order-container__header">
        <div className="order-container__title-block">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className="order-container__icon">
            <rect x="0.43125" y="1.025" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M12.675 7.83333C12.675 8.56971 11.0129 9.16667 8.9625 9.16667C6.91214 9.16667 5.25 8.56971 5.25 7.83333M12.675 7.83333C12.675 7.09695 11.0129 6.5 8.9625 6.5C6.91214 6.5 5.25 7.09695 5.25 7.83333M12.675 7.83333V8.83333M5.25 7.83333V15.8333C5.25 16.5697 6.91214 17.1667 8.9625 17.1667M8.9625 11.8333C8.84873 11.8333 8.73616 11.8315 8.625 11.8279C6.73281 11.7667 5.25 11.1955 5.25 10.5M8.9625 14.5C6.91214 14.5 5.25 13.903 5.25 13.1667M18.75 12.1667C18.75 12.903 17.0879 13.5 15.0375 13.5C12.9871 13.5 11.325 12.903 11.325 12.1667M18.75 12.1667C18.75 11.4303 17.0879 10.8333 15.0375 10.8333C12.9871 10.8333 11.325 11.4303 11.325 12.1667M18.75 12.1667V17.1667C18.75 17.903 17.0879 18.5 15.0375 18.5C12.9871 18.5 11.325 17.903 11.325 17.1667V12.1667M18.75 14.6667C18.75 15.403 17.0879 16 15.0375 16C12.9871 16 11.325 15.403 11.325 14.6667" stroke="#1570EF" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <p className="order-container__title">Buy ASICs /</p>
          <p className="order-container__subtitle">Payment Details</p>
        </div>
        <button className="ui-back order-container__back" type="button" onClick={handleBack}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15.8333 9.99996H4.16663M4.16663 9.99996L9.99996 15.8333M4.16663 9.99996L9.99996 4.16663" stroke="#475467" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <p className="ui-back__button">Back</p>
        </button>
      </div>

      {/* Hardware Section */}
      <div className="holder wrapper-hardware-section">
        <div className="wrapper-hardware">
          {/* Hardware Wrapper Section */}
          <div className="wrapper-hardware">
            <div className="wrapper-hardware__info">
              <div className="wrapper-hardware__info-details">
                <p className="wrapper-hardware__title">{asic.title}</p>
                <div className="wrapper-hardware__image-block" style={{ height: '127px' }}>
                  <div className="wrapper-hardware__asic-image">
                    <img className="wrapper-hardware__img-asic" src={asic.image} alt="asic" />
                  </div>
                  <div className="wrapper-hardware__duration-block">
                    <p className="wrapper-hardware__duration">Setup 14 days</p>
                  </div>
                </div>
                <div className="wrapper-hardware__info-details__quantity">
                  <p className="wrapper-hardware__info-details__quantity-title">Quantity</p>
                  <div className="wrapper-hardware__info-details__quantity-button-block">
                    <button className="transparent wrapper-hardware__info-details__quantity-button" onClick={decreaseQuantity}>-</button>
                    <p className="wrapper-hardware__info-details__quantity-value">{quantity}</p>
                    <button className="transparent wrapper-hardware__info-details__quantity-button" onClick={increaseQuantity}>+</button>
                  </div>
                </div>
              </div>

              {/* Hardware Details Section */}
              <div className="wrapper-hardware__asic-hardware-info">
                <div className="wrapper-hardware__hardware">
                  <div className="wrapper-hardware__title-block" onClick={toggleHardwareDetails}>
                    <h2>Hardware Details</h2>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="wrapper-hardware__chevron" style={{ transform: hardwareDetailsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
                      <path d="M5 7.5L10 12.5L15 7.5" stroke="#1570EF" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  {hardwareDetailsOpen && (
                    <div style={{ width: '100%' }}>
                      <div className="wrapper-hardware__info-block">
                        <div className="wrapper-hardware__line line">
                          <div className="text_group textborder">
                            <p className="text_title">Power</p>
                            <p className="text_value">{asic.powerW}</p>
                          </div>
                          <div className="text_group">
                            <p className="text_title">Mining Power</p>
                            <p className="text_value">{asic.power}</p>
                          </div>
                        </div>
                        <div className="wrapper-hardware__line line">
                          <div className="text_group textborder">
                            <p className="text_title">Algorithm</p>
                            <p className="text_value">{asic.algorithm}</p>
                          </div>
                          <div className="text_group">
                            <p className="text_title">Efficiency</p>
                            <p className="text_value">{asic.efficiency}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Hosting Section */}
                  <div className="wrapper-hardware__including">
                    <h2>Hosting at FX-Pool Data Center</h2>
                    <div className="wrapper-hardware__group-icon-block">
                      <div className="wrapper-hardware__group-icon-text icon-border">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="wrapper-hardware__icon-text">
                          <path d="M10.5337 10.5341V4.32745C10.5337 3.61805 10.5337 3.26335 10.3956 2.99239C10.2742 2.75405 10.0804 2.56028 9.84205 2.43884C9.57109 2.30078 9.21639 2.30078 8.50699 2.30078H3.69366C2.98426 2.30078 2.62956 2.30078 2.3586 2.43884C2.12027 2.56028 1.92649 2.75405 1.80505 2.99239C1.66699 3.26335 1.66699 3.61805 1.66699 4.32745V8.50745C1.66699 9.21685 1.66699 9.57155 1.80505 9.8425C1.92649 10.0808 2.12027 10.2746 2.3586 10.3961C2.62956 10.5341 2.98426 10.5341 3.69366 10.5341H10.5337ZM10.5337 10.5341H13.3203C13.675 10.5341 13.8524 10.5341 13.9879 10.4651C14.107 10.4044 14.2039 10.3075 14.2646 10.1883C14.3337 10.0528 14.3337 9.87548 14.3337 9.52078V7.78718C14.3337 7.63228 14.3337 7.55482 14.3162 7.48193C14.3006 7.41731 14.2751 7.35553 14.2403 7.29887C14.2012 7.23495 14.1464 7.18019 14.0369 7.07065L12.7305 5.76425C12.6209 5.65471 12.5662 5.59994 12.5022 5.56078C12.4456 5.52605 12.3838 5.50046 12.3192 5.48495C12.2463 5.46745 12.1688 5.46745 12.0139 5.46745H10.5337M6.10033 12.1174C6.10033 12.9919 5.39144 13.7008 4.51699 13.7008C3.64254 13.7008 2.93366 12.9919 2.93366 12.1174C2.93366 11.243 3.64254 10.5341 4.51699 10.5341C5.39144 10.5341 6.10033 11.243 6.10033 12.1174ZM13.067 12.1174C13.067 12.9919 12.3581 13.7008 11.4837 13.7008C10.6092 13.7008 9.90033 12.9919 9.90033 12.1174C9.90033 11.243 10.6092 10.5341 11.4837 10.5341C12.3581 10.5341 13.067 11.243 13.067 12.1174Z" stroke="#475467" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        <p className="wrapper-hardware__text">Shipping and TAX</p>
                      </div>
                      <div className="wrapper-hardware__group-icon-text icon-border">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="wrapper-hardware__icon-text">
                          <path d="M3.52051 3.51329C3.52051 2.89174 3.52051 2.58097 3.6501 2.40966C3.763 2.26042 3.93556 2.16807 4.12236 2.15691C4.33679 2.14411 4.59536 2.3165 5.11252 2.66127L11.8425 7.14791C12.2698 7.43279 12.4835 7.57523 12.5579 7.75476C12.623 7.91172 12.623 8.08813 12.5579 8.24509C12.4835 8.42463 12.2698 8.56707 11.8425 8.85195L5.11252 13.3386C4.59536 13.6834 4.33679 13.8557 4.12236 13.8429C3.93556 13.8318 3.763 13.7394 3.6501 13.5902C3.52051 13.4189 3.52051 13.1081 3.52051 12.4866V3.51329Z" stroke="#475467" strokeWidth="1.28" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        <p className="wrapper-hardware__text">Set up and launch</p>
                      </div>
                      <div className="wrapper-hardware__group-icon-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className="wrapper-hardware__icon-text">
                          <path d="M4.20033 4.20033L7.05033 7.05033M4.20033 4.20033H2.30033L1.66699 2.30033L2.30033 1.66699L4.20033 2.30033V4.20033ZM12.5977 2.1363L10.9335 3.80046C10.6827 4.05127 10.5573 4.17667 10.5103 4.32128C10.469 4.44848 10.469 4.5855 10.5103 4.7127C10.5573 4.85731 10.6827 4.98272 10.9335 5.23353L11.0838 5.38379C11.3346 5.6346 11.46 5.76001 11.6046 5.80699C11.7318 5.84832 11.8688 5.84832 11.996 5.80699C12.1406 5.76001 12.2661 5.6346 12.5169 5.38379L14.0735 3.82711C14.2412 4.23509 14.3337 4.68191 14.3337 5.15033C14.3337 7.07412 12.7741 8.63366 10.8503 8.63366C10.6184 8.63366 10.3918 8.61099 10.1725 8.56775C9.86462 8.50703 9.71067 8.47667 9.61734 8.48597C9.51813 8.49585 9.46923 8.51073 9.38132 8.55778C9.29862 8.60203 9.21568 8.68498 9.04978 8.85087L4.51699 13.3837C3.99232 13.9083 3.14166 13.9083 2.61699 13.3837C2.09232 12.859 2.09232 12.0083 2.61699 11.4836L7.14978 6.95087C7.31568 6.78498 7.39862 6.70203 7.44288 6.61933C7.48992 6.53142 7.5048 6.48252 7.51468 6.38331C7.52398 6.28998 7.49362 6.13603 7.4329 5.82814C7.38966 5.6089 7.36699 5.38226 7.36699 5.15033C7.36699 3.22653 8.92653 1.66699 10.8503 1.66699C11.4871 1.66699 12.084 1.83788 12.5977 2.1363ZM8.00036 9.90029L11.4837 13.3836C12.0083 13.9083 12.859 13.9083 13.3837 13.3836C13.9083 12.8589 13.9083 12.0083 13.3836 11.4836L10.518 8.61801C10.3152 8.59882 10.1174 8.56222 9.92616 8.50974C9.67975 8.4421 9.40946 8.49119 9.22878 8.67187L8.00036 9.90029Z" stroke="#475467" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        <p className="wrapper-hardware__text">24/7 Maintenance and Security</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Profitability Info */}
              <div className="wrapper-hardware__profitability_info">
                <p className="wrapper-hardware__profitability_info-title">Profitability Info</p>
                <div className="wrapper-hardware__profitability_info-block">
                  <div className="wrapper-hardware__profitability_info-group">
                    <p className="wrapper-hardware__profitability_info-group-title">Monthly Mining Output</p>
                    <p className="wrapper-hardware__profitability_info-group-value">${asic.monthlyOutput}</p>
                  </div>
                  <span className="wrapper-hardware__profitability_info-border"></span>
                  <div className="wrapper-hardware__profitability_info-group">
                    <p className="wrapper-hardware__profitability_info-group-title">Breakeven</p>
                    <p className="wrapper-hardware__profitability_info-group-value">{asic.breakeven} days</p>
                  </div>
                  <span className="wrapper-hardware__profitability_info-border"></span>
                  <div className="wrapper-hardware__profitability_info-group">
                    <p className="wrapper-hardware__profitability_info-group-title">Return</p>
                    <p className="wrapper-hardware__profitability_info-group-value">{asic.return}%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      {/* Order Details Section */}
      <div className="holder order-details-section">
          <div className="order-details">
            <div className="order-details__title-block">
              <h2 className="order-details__title">Payment Details</h2>
            </div>
            <div className="order-details__items">
              <div className="order-details__subtitle-block">
                <p className="order-details__subtitle"></p>
                <p className="order-details__subtitle">Price</p>
                <p className="order-details__subtitle">Quantity</p>
                <p className="order-details__subtitle">Total</p>
              </div>
              <div className="order-details__item">
                <div className="order-details__item-name">{asic.title}</div>
                <div className="order-details__item-price" style={{ textAlign: 'start' }}>
                  <span className="order-details__price-background">{formatCurrency(asic.price)}</span>
                </div>
                <div className="order-details__item-quantity">{quantity}</div>
                <div className="order-details__item-total">{formatCurrency(asicSubtotal)}</div>
              </div>
              <div className="order-details__item">
                <div className="order-details__item-name">
                  Installation Fee
                  <div className="tooltip order-details__custom-tooltip">
                    <div className="tooltip-text">One-time payment that covers logistics, customs clearance and installation costs</div>
                    <svg className="default" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <g clipPath="url(#clip0_264_44934)">
                        <path d="M9.00018 12.2727V8.99999M9.00018 5.72727H9.00836M17.182 8.99999C17.182 13.5187 13.5189 17.1818 9.00018 17.1818C4.48148 17.1818 0.818359 13.5187 0.818359 8.99999C0.818359 4.4813 4.48148 0.818176 9.00018 0.818176C13.5189 0.818176 17.182 4.4813 17.182 8.99999Z" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_264_44934">
                          <rect width="18" height="18" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="order-details__item-price" style={{ textAlign: 'start' }}>
                  <span className="order-details__price-background">{formatCurrency(installationFeePerUnit)}</span>
                </div>
                <div className="order-details__item-quantity">{quantity}</div>
                <div className="order-details__item-total">{formatCurrency(installationFeeTotal)}</div>
              </div>
              <div className="order-details__item">
                <div className="order-details__item-name">
                  Monthly Hosting Fee
                  <div className="tooltip order-details__custom-tooltip">
                    <div className="tooltip-text">Monthly charge covering electricity and maintenance</div>
                    <svg className="default" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <g clipPath="url(#clip0_264_44934)">
                        <path d="M9.00018 12.2727V8.99999M9.00018 5.72727H9.00836M17.182 8.99999C17.182 13.5187 13.5189 17.1818 9.00018 17.1818C4.48148 17.1818 0.818359 13.5187 0.818359 8.99999C0.818359 4.4813 4.48148 0.818176 9.00018 0.818176C13.5189 0.818176 17.182 4.4813 17.182 8.99999Z" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_264_44934">
                          <rect width="18" height="18" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="order-details__item-price" style={{ textAlign: 'start' }}>
                  <span className="order-details__price-background">{formatCurrency(monthlyHostingFeePerUnit)}</span>
                </div>
                <div className="order-details__item-quantity">{quantity}</div>
                <div className="order-details__item-total">{formatCurrency(monthlyHostingFeeTotal)}</div>
              </div>
            </div>
            <div className="order-details__summary">
              <div className="order-details__discount-promo-block">
                <div className="order-details__discount-promo">
                  <p className="order-details__summary-title">Promocode:</p>
                  <div className="order-details__promocode-block">
                    <input 
                      className="order-details__promocode" 
                      placeholder="Promocode" 
                      value={promocode}
                      onChange={(e) => setPromocode(e.target.value)}
                    />
                    <button className="transparent order-details__promocode-btn" type="button">Confirm</button>
                  </div>
                </div>
              </div>
              <div className="order-details__discount">
                <div className="order-details__summary-title-block">
                  <p className="order-details__summary-title">Discount</p>
                  <p className="order-details__summary-subtitle">For bulk orders of 5+ or 10+ units, get up to 15% off.</p>
                </div>
                <div className="order-details__summary-value-block">
                  <p className="order-details__summary-discount-value">{formatCurrency(discount)}</p>
                  <span className="order-details__summary-discount-percent">{discountPercent}%</span>
                </div>
              </div>
              <div className="order-details__total">
                <p className="order-details__summary-title">Total Payment</p>
                <p className="order-details__summary-value">{formatCurrency(total)}</p>
              </div>
            </div>
          </div>
      </div>

      {/* Payment Options Section */}
      <div className="holder order-container__payment-options">
            <div className="container-payment">
              <div className="payment-container tariff_page_old">
                <div className="payment-container__form-payment">
                  <div className="payment-container__payment-title">Payment Options:</div>
                  <div className="payment-container__form-payment-block">
                    <div className="payment-container__form-payment-list-block">
                      <div className="payment-container__form-payment-list">
                        <button 
                          className={`ui-payment-method-button ${selectedPaymentMethod === 'card' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handlePaymentMethodSelect('card')}
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ui-payment-method-button__icon">
                            <rect x="2" y="5" width="20" height="14" rx="2" stroke="#1570EF" strokeWidth="2"/>
                            <path d="M2 9H22" stroke="#1570EF" strokeWidth="2"/>
                            <rect x="5" y="13" width="6" height="2" rx="1" fill="#1570EF"/>
                          </svg>
                          <span className="ui-payment-method-button__text">Card</span>
                        </button>
                        <button 
                          className={`ui-payment-method-button ${selectedPaymentMethod === 'bank' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handlePaymentMethodSelect('bank')}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ui-payment-method-button__icon">
                            <path d="M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z" stroke="#1570EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                          </svg>
                          <span className="ui-payment-method-button__text">Bank Transfer</span>
                        </button>
                        <button 
                          className={`ui-payment-method-button ${selectedPaymentMethod === 'btc' ? 'active' : ''}`}
                          type="button"
                          onClick={() => handlePaymentMethodSelect('btc')}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ui-payment-method-button__icon">
                            <circle cx="12" cy="12" r="12" fill="#F7931A"></circle>
                            <path d="M6.713 6.60268L9.568 6.60229L9.56874 4.22359L10.9975 4.22813L10.9954 6.50894L12.16 6.50973L12.157 4.20545L13.6092 4.20484L13.6048 6.52353C13.6048 6.52353 15.9489 6.42059 16.9517 8.08089C17.9545 9.74119 16.5429 11.1325 16.0383 11.3061C16.0383 11.3061 18.262 11.8498 18.1565 14.1199C18.051 16.39 16.107 17.3119 13.8279 17.4087L13.8449 19.8075L12.3927 19.8081L12.3966 17.441L11.2432 17.436L11.2436 19.8189L9.80222 19.8178L9.80571 17.4451L6.87362 17.4402L7.15279 15.7255C7.15279 15.7255 7.9806 15.7296 8.29112 15.7209C8.60164 15.7123 8.70789 15.3585 8.70876 15.033C8.70964 14.7075 8.60013 9.34629 8.60613 8.90083C8.61213 8.45537 8.47804 8.14458 7.95283 8.14865C7.42762 8.15272 6.70619 8.13257 6.70619 8.13257L6.713 6.60268ZM11.1848 12.5434L11.2329 15.6736C11.2329 15.6736 15.2442 16.0139 15.2143 14.0308C15.1844 12.0477 11.1848 12.5434 11.1848 12.5434ZM11.1514 11.0615L11.1553 8.18052C11.1553 8.18052 14.4372 7.90197 14.4522 9.50056C14.4672 11.0992 12.4674 11.0206 11.1514 11.0615Z" fill="white"></path>
                          </svg>
                          <span className="ui-payment-method-button__text">BTC</span>
                        </button>
                        <div className="ui-payment-dropdown">
                          <button 
                            className={`ui-payment-method-button ui-payment-dropdown-toggle ${selectedPaymentMethod === 'crypto' || otherCryptoOpen ? 'active' : ''}`}
                            type="button"
                            onClick={toggleOtherCrypto}
                          >
                            <span className="ui-payment-method-button__text">
                              Other Crypto
                            </span>
                            <svg 
                              xmlns="http://www.w3.org/2000/svg" 
                              width="16" 
                              height="16" 
                              viewBox="0 0 16 16" 
                              fill="none"
                              className="ui-payment-dropdown-arrow"
                              style={{ transform: otherCryptoOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                            >
                              <path d="M4 6L8 10L12 6" stroke="#1570EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                          </button>
                          {otherCryptoOpen && (
                            <div className="ui-payment-dropdown-content">
                              <button 
                                className={`ui-payment-dropdown-item ${selectedPaymentMethod === 'eth' ? 'active' : ''}`}
                                type="button"
                                onClick={() => handlePaymentMethodSelect('eth')}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <circle cx="10" cy="10" r="10" fill="#627EEA"/>
                                  <path d="M10 3.5L9.875 3.925V12.575L10 12.7L13.875 10.425L10 3.5Z" fill="white" fillOpacity="0.6"/>
                                  <path d="M10 3.5L6.125 10.425L10 12.7V3.5Z" fill="white"/>
                                  <path d="M10 13.525L9.9375 13.6V16.3625L10 16.525L13.875 11.25L10 13.525Z" fill="white" fillOpacity="0.6"/>
                                  <path d="M10 16.525V13.525L6.125 11.25L10 16.525Z" fill="white"/>
                                </svg>
                                <span>Ethereum (ETH)</span>
                              </button>
                              <button 
                                className={`ui-payment-dropdown-item ${selectedPaymentMethod === 'usdt' ? 'active' : ''}`}
                                type="button"
                                onClick={() => handlePaymentMethodSelect('usdt')}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <circle cx="10" cy="10" r="10" fill="#26A17B"/>
                                  <path d="M11.5 8.8H13.5V6.5H11.5V8.8ZM8.5 8.8V6.5H6.5V8.8H8.5ZM10 10.5C8.9 10.5 8 10.6 8 10.7C8 10.8 8.9 10.9 10 10.9C11.1 10.9 12 10.8 12 10.7C12 10.6 11.1 10.5 10 10.5ZM13.5 9.3H11.5V9.7C11.5 9.8 11.1 10.1 10 10.1C8.9 10.1 8.5 9.8 8.5 9.7V9.3H6.5C6.5 9.5 6.9 11.3 10 11.3C13.1 11.3 13.5 9.5 13.5 9.3Z" fill="white"/>
                                </svg>
                                <span>Tether (USDT)</span>
                              </button>
                              <button 
                                className={`ui-payment-dropdown-item ${selectedPaymentMethod === 'usdc' ? 'active' : ''}`}
                                type="button"
                                onClick={() => handlePaymentMethodSelect('usdc')}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <circle cx="10" cy="10" r="10" fill="#2775CA"/>
                                  <path d="M12.5 9.5C12.5 8.4 11.8 7.8 10 7.6V11.4C11.8 11.2 12.5 10.6 12.5 9.5ZM10 11.8V13.5H10.5V11.8C12.3 11.6 13.5 10.8 13.5 9.5C13.5 8.2 12.3 7.4 10.5 7.2V5.5H10V7.2C8.2 7.4 7 8.2 7 9.5C7 10.8 8.2 11.6 10 11.8ZM10 7.6C8.2 7.8 7.5 8.4 7.5 9.5C7.5 10.6 8.2 11.2 10 11.4V7.6Z" fill="white"/>
                                </svg>
                                <span>USD Coin (USDC)</span>
                              </button>
                              <button 
                                className={`ui-payment-dropdown-item ${selectedPaymentMethod === 'bnb' ? 'active' : ''}`}
                                type="button"
                                onClick={() => handlePaymentMethodSelect('bnb')}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <circle cx="10" cy="10" r="10" fill="#F3BA2F"/>
                                  <path d="M7.5 10L10 7.5L12.5 10L10 12.5L7.5 10ZM10 6L13.5 9.5L15 8L10 3L5 8L6.5 9.5L10 6ZM4 10L5.5 11.5L7 10L5.5 8.5L4 10ZM10 14L6.5 10.5L5 12L10 17L15 12L13.5 10.5L10 14ZM13 10L14.5 11.5L16 10L14.5 8.5L13 10Z" fill="white"/>
                                </svg>
                                <span>BNB</span>
                              </button>
                              <button 
                                className={`ui-payment-dropdown-item ${selectedPaymentMethod === 'sol' ? 'active' : ''}`}
                                type="button"
                                onClick={() => handlePaymentMethodSelect('sol')}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <circle cx="10" cy="10" r="10" fill="url(#solana-gradient)"/>
                                  <defs>
                                    <linearGradient id="solana-gradient" x1="0" y1="0" x2="20" y2="20">
                                      <stop offset="0%" stopColor="#00FFA3"/>
                                      <stop offset="100%" stopColor="#DC1FFF"/>
                                    </linearGradient>
                                  </defs>
                                  <path d="M6.5 12.5L8 11H14L12.5 12.5H6.5ZM6.5 10L8 8.5H14L12.5 10H6.5ZM6.5 7.5L8 6H14L12.5 7.5H6.5Z" fill="white"/>
                                </svg>
                                <span>Solana (SOL)</span>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="payment-container__button-block">
                  <div className="payment-container__checked-privacy_policy">
                    <label className="ui-checkbox payment-container__form-confirm-checkbox">
                      <input 
                        type="checkbox" 
                        className="ui-checkbox__input" 
                        checked={agreedToTerms}
                        onChange={(e) => setAgreedToTerms(e.target.checked)}
                      />
                      <span className="ui-checkbox__visual"></span>
                      <span className="ui-checkbox__wrap">
                        <span className="ui-checkbox__text">
                          <div className="checked_box">
                            <span className="payment-container__text">I agree to your</span>
                            <a className="payment-container__link" href="#" onClick={(e) => e.preventDefault()}>Refund Policy</a>
                            <span className="payment-container__text">and</span>
                            <a className="payment-container__link" href="#" onClick={(e) => e.preventDefault()}>Terms of use</a>
                          </div>
                        </span>
                      </span>
                    </label>
                  </div>
                  <div className="payment-container____button-block">
                    <button 
                      className={`orange ${!agreedToTerms ? 'disabled' : ''}`} 
                      type="button" 
                      disabled={!agreedToTerms}
                    >
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      {/* Disclaimer Section */}
      <div className="holder order-container__disclaimer-section">
        <div className="disclaimer">
          <p className="disclaimer__title">Disclaimer</p>
          <p className="disclaimer__description">These estimates offer forward-looking information based on current data, including mining difficulty: FPPS 0.00000041, and BTC reference rate of $175k. They are not guarantees of future results and should be viewed with caution due to market uncertainties.</p>
        </div>
      </div>
    </div>
  );
};

export default BuyAsicsPayment;

